import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import usePortalAuth from '../../../auth/usePortalAuth';

//------Material UI-----//
import { makeStyles, useTheme } from '@material-ui/core/styles';
//import SchoolIcon from '@material-ui/icons/School';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TrainingItemCard from './TrainingItemCard';
import TrainingTotalsWidget from './TrainingTotalsWidget';
import basePCUrl from '../../../Globals';
import useChangePageTitle from '../CustomHooks/useChangePageTitle';

//----Images/Assets----//
import TrainingImagePlaceholder from './Images/TrainingImagePlaceholder.png';

//----CSS/Styling Sheet----//
import './TrainingSuite.css';

const trainingAPI = 'https://zsvz1vz9rg.execute-api.us-west-2.amazonaws.com/prod';
const TrainingSuite = (props) => {
  useChangePageTitle('TrainingSuite');
  const {
    courseData: { isLoading, data, isError, error },
  } = props;
  //const [isLoading, setIsLoading] = useState();
  //const [data, setTrainingData] = useState(data);

  const [trainingStatus, setTrainingStatus] = useState([]);
  const [modId, setModId] = useState([]);

  const [trainingSetStatusArray, setTrainingSetStatusArray] = useState([]);
  const [modIdArray, setModIdArray] = useState([]);

  const [finalTrainingSettingsList, setFinalTrainingSettingsList] = useState();

  const { getAccessTokenSilently } = usePortalAuth();
  const clientId = props.selectedClient;

  //-------Settings Saved Message------//
  const ShowSuccessMessage = (msg) => {
    let x = document.getElementById('successMessage');
    x.innerHTML = msg;
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 7000);
  };

  //-----Modern Styling-----//
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      background: theme.palette.type === 'dark' ? theme.palette.background.default : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: '100vh',
      padding: theme.spacing(3),
    },
    heroSection: {
      background: 'linear-gradient(135deg, #061739 0%, #0055A2 50%, #428BC9 100%)',
      color: 'white',
      borderRadius: 16,
      padding: theme.spacing(4),
      marginBottom: theme.spacing(3),
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(1px)',
      },
    },
    heroContent: {
      position: 'relative',
      zIndex: 1,
    },
    statsContainer: {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 16,
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px rgba(0, 85, 162, 0.1)',
    },
    modernCard: {
      borderRadius: 16,
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 12px 40px rgba(0, 85, 162, 0.2)',
      },
    },
    saveButton: {
      background: 'linear-gradient(45deg, #0055A2, #428BC9)',
      color: 'white',
      fontWeight: 600,
      padding: '12px 32px',
      borderRadius: 25,
      fontSize: '1rem',
      textTransform: 'none',
      boxShadow: '0 4px 20px rgba(0, 85, 162, 0.3)',
      '&:hover': {
        background: 'linear-gradient(45deg, #061739, #0055A2)',
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 25px rgba(0, 85, 162, 0.4)',
      },
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 300,
    },
  }));

  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.root}>
      {/* Hero Section */}
      <Paper className={classes.heroSection} elevation={0}>
        <div className={classes.heroContent}>
          <Typography variant="h3" style={{ fontWeight: 700, marginBottom: 16 }}>
            🎓 Training Suite
          </Typography>
          <Typography variant="h6" style={{ opacity: 0.9, marginBottom: 0, fontWeight: 400 }}>
            Manage and track your cybersecurity training modules
          </Typography>
        </div>
      </Paper>

      {/* Stats Section */}
      <Paper className={classes.statsContainer} elevation={0}>
        <Typography variant="h5" style={{ fontWeight: 600, marginBottom: 24, textAlign: 'center', color: theme.palette.type === 'dark' ? theme.palette.text.primary : '#1a237e' }}>
          📊 Training Progress Overview
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4} md={4}>
            <div style={{ textAlign: 'center', padding: 16 }}>
              <Typography variant="h2" style={{ fontWeight: 700, color: '#f44336', marginBottom: 8 }}>
                {data?.numberAssigned || 0}
              </Typography>
              <Typography variant="h6" style={{ color: '#666', fontWeight: 500 }}>
                Assigned
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <div style={{ textAlign: 'center', padding: 16 }}>
              <Typography variant="h2" style={{ fontWeight: 700, color: '#2196f3', marginBottom: 8 }}>
                {data?.numberInProgress || 0}
              </Typography>
              <Typography variant="h6" style={{ color: '#666', fontWeight: 500 }}>
                In Progress
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <div style={{ textAlign: 'center', padding: 16 }}>
              <Typography variant="h2" style={{ fontWeight: 700, color: '#4caf50', marginBottom: 8 }}>
                {data?.numberCompleted || 0}
              </Typography>
              <Typography variant="h6" style={{ color: '#666', fontWeight: 500 }}>
                Completed
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Paper>

      {/* Training Modules Section */}
      <Typography variant="h4" style={{ fontWeight: 700, marginBottom: 24, textAlign: 'center', color: theme.palette.type === 'dark' ? theme.palette.text.primary : '#1a237e' }}>
        📚 Available Training Modules
      </Typography>

      <Grid container spacing={3}>
        {isLoading === false && data !== undefined ? (
          data.trainingItems.map((training, idx) => (
            <TrainingItemCard
              key={idx}
              title={training.description}
              status={training.status}
              timeEstimate={Math.floor(training.timeEstimate / 60) + ' minutes'}
              image={training.thumbnail}
              description={''}
              modId={modIdArray}
              accessibleTitle={training.description}
              trainingDetails={training.modId}
              history={props.history}
              accessLevel={props.accessLevel}
              modernStyle={true}
            />
          ))
        ) : (
          <div className={classes.loadingContainer}>
            <Typography variant="h6" color="textSecondary">
              {isLoading ? 'Loading training modules...' : 'No training modules available'}
            </Typography>
          </div>
        )}
      </Grid>

      {/* Success Message */}
      <div id="successMessage" />
      
      {/* Save Button */}
      <div style={{ textAlign: 'center', marginTop: 40, marginBottom: 40 }}>
        <Button className={classes.saveButton} variant="contained">
          💾 Save Training Settings
        </Button>
      </div>
    </div>
  );
};
export default TrainingSuite;
